import React, { ReactElement } from 'react';
import Table from '../../../../components/table/table.component';
import TableBody from '../../../../components/table-body/table-body.component';
import TableRow from '../../../../components/table-row/table-row.component';
import TableCell from '../../../../components/table-cell/table-cell.component';
import Hint from '../../../../components/hint/hint.component';
import FormFieldText from '../../../../components/form-field-text/form-field-text.component';
import SinglePageTab from '../../../app/common/single-page-tab/single-page-tab.component';

const SettingsAccountOkta: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isSaving,
    isSaveDisabled,
    isEditMode,
    isRightDrawerOpen,
    accountData,
    formError,
    onCancelForm,
    onSubmitForm,
  } = props;

  const isEmpty: boolean = !accountData.oktaAccountName && !accountData.oktaAccountClientId && !isEditMode;
  const formPrefix: string = 'account';

  return (
    <SinglePageTab
      isSaving={isSaving}
      isSaveDisabled={isSaveDisabled}
      isEditMode={isEditMode}
      isRightDrawerOpen={isRightDrawerOpen}
      isEmpty={isEmpty}
      formError={formError}
      onCancelForm={onCancelForm}
      onSubmitForm={onSubmitForm}
    >
      <Table>
        <TableBody isPlain withNoBorders withTwoColumns withHeaderColumn>
          {
            (accountData.oktaAccountName || isEditMode) && (
              <TableRow>
                <TableCell>
                  Okta Account Name (subdomain)
                  <Hint title="Okta subdomain name (like https://[AccountName].okta.com/)" />
                </TableCell>
                <TableCell>
                  {
                    isEditMode ? (
                      <FormFieldText isBordered name={`${formPrefix}.oktaAccountName`} />
                    ) : accountData.oktaAccountName
                  }
                </TableCell>
              </TableRow>
            )
          }
          {
            (accountData.oktaAccountClientId || isEditMode) && (
              <TableRow>
                <TableCell>
                  Okta Account Client ID
                </TableCell>
                <TableCell>
                  {
                    isEditMode ? (
                      <FormFieldText isBordered name={`${formPrefix}.oktaAccountClientId`} />
                    ) : accountData.oktaAccountClientId
                  }
                </TableCell>
              </TableRow>
            )
          }
        </TableBody>
      </Table>
    </SinglePageTab>
  );
});

export default SettingsAccountOkta;
